import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import LoadingPopup from "./loading";
import { secretKey } from "./data";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import LeadDetail from "./leadDetail";

const MySwal = withReactContent(Swal2);

const SendClientsResults = (props) => {
  const [loading, setLoading] = useState(true);
  const [results, setResults] = useState([]);
  const [resultsBody, setResultsBody] = useState([]);
  const [from, setFrom] = useState(
    new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1 < 10
        ? "0" + (new Date().getMonth() + 1)
        : new Date().getMonth() + 1) +
      "-" +
      (new Date().getDate() < 10
        ? "0" + new Date().getDate()
        : new Date().getDate())
  );
  const [to, setTo] = useState(
    new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1 < 10
        ? "0" + (new Date().getMonth() + 1)
        : new Date().getMonth() + 1) +
      "-" +
      (new Date().getDate() < 10
        ? "0" + new Date().getDate()
        : new Date().getDate())
  );

  const fetchClients = async () => {
    var body = { from: from, to: to };

    await fetch("https://apisellcrm.ftpeople.pl/getSendLeadsResults", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var arr = [];
        data
          .sort(function (a, b) {
            return new Date(b.date) - new Date(a.date);
          })
          .map((el) => {
            if (arr.filter((e) => e === el.assDate).length === 0) {
              arr.push(el.assDate);
            }
          });
        setResults(
          data.sort(function (a, b) {
            return new Date(b.date) - new Date(a.date);
          })
        );
        setResultsBody(arr);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    fetchClients();
  };

  useEffect(() => {
    getData();
  }, []);

  const getResult = () => {
    if (new Date(to) < new Date(from)) {
      MySwal.fire({
        icon: "error",
        title: "Data do",
        text: 'nie może być mniejsza niż "Data od"',
      });
      return;
    }
    if (new Date(from) > new Date(to)) {
      MySwal.fire({
        icon: "error",
        title: "Data od",
        text: 'nie może być większa niż "Data do"',
      });
      return;
    }
    if (from && to) {
      getData();
    }
  };

  const getSum = (date, type) => {
    var sum = 0;
    results.map((el) => {
      if (el.assDate === date && (type === "all" ? true : type === el.type)) {
        sum = sum + el.sum;
      }
    });

    return sum;
  };

  const getSumRep = () => {
    var sum = 0;
    results.map((el) => {
      sum = sum + el.sum;
    });

    return sum;
  };

  return (
    <div>
      {loading ? (
        <LoadingPopup />
      ) : (
        <>
          <div style={{ textAlign: "left" }}>
            <div style={{ display: "block", width: "40%" }}>
              <div
                style={{
                  marginBottom: "1vh",
                  width: "100%",
                  textAlign: "left",
                }}
              >
                <label
                  style={{
                    fontSize: ".6vw",
                    fontWeight: "600",
                    paddingLeft: "5px",
                  }}
                >
                  zakres raportu
                </label>
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    width: "100%",
                  }}
                  className="inputBox"
                >
                  <div style={{ width: "45%" }}>
                    <label
                      style={{
                        fontSize: ".6vw",
                        paddingLeft: "5px",
                      }}
                    >
                      od
                    </label>
                    <input
                      style={{ height: "3vh", width: "100%" }}
                      type="date"
                      id="name"
                      name="name"
                      value={from}
                      onChange={(e) => {
                        setFrom(e.target.value);
                      }}
                    />
                  </div>
                  <div style={{ width: "45%" }}>
                    <label
                      style={{
                        fontSize: ".6vw",
                        paddingLeft: "5px",
                      }}
                    >
                      do
                    </label>
                    <input
                      style={{ height: "3vh", width: "100%" }}
                      type="date"
                      id="name"
                      name="name"
                      value={to}
                      onChange={(e) => {
                        setTo(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div style={{ marginTop: "10px", textAlign: "left" }}>
                  <button
                    style={{
                      backgroundColor: "navy",
                      border: "none",
                      color: "white",
                      textTransform: "uppercase",
                      fontWeight: "600",
                      borderRadius: "5px",
                    }}
                    id="clientsFilterButton"
                    className="paymentMenuButton"
                    onClick={getResult}
                  >
                    Zastosuj
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div style={{ textAlign: "left", marginTop: "5vh" }}>
            <p style={{ fontSize: "2vw", fontWeight: "900" }}>
              SUMA RAPORTU - {getSumRep()} zł netto
            </p>
            <table
              style={{ marginTop: "3vh", fontSize: ".8vw" }}
              className="clients_table"
            >
              <tr key={0} style={{ textAlign: "center" }}>
                <th>data</th>
                <th>suma</th>
                <th>CHF</th>
                <th>SKD</th>
                <th>WIBOR</th>
              </tr>
              {resultsBody.map((res) => (
                <tr>
                  <td>{res}</td>
                  <td>{getSum(res, "all")} zł netto</td>
                  <td style={{ fontSize: ".6vw" }}>
                    {getSum(res, "CHF")} zł netto
                  </td>
                  <td style={{ fontSize: ".6vw" }}>
                    {getSum(res, "SKD")} zł netto
                  </td>
                  <td style={{ fontSize: ".6vw" }}>
                    {getSum(res, "WIBOR")} zł netto
                  </td>
                </tr>
              ))}
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default SendClientsResults;
